import { render, staticRenderFns } from "./formSearch.vue?vue&type=template&id=6016fbbc&scoped=true"
import script from "./formSearch.vue?vue&type=script&lang=js"
export * from "./formSearch.vue?vue&type=script&lang=js"
import style0 from "./formSearch.vue?vue&type=style&index=0&id=6016fbbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6016fbbc",
  null
  
)

export default component.exports